import { cssUtil } from "../utils/cssUtil.js";
import { getBaseStyles } from "./commonStyles.js";
const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;

export function renderVideoWidget(context, widget, parent, override = null) {

    const videoUrl = getVideoUrl(context, widget);
    if (!videoUrl) return;

    // wrapper
    const container = context.document.createElement("div");
    container.classList.add("widget", "video_widget");
    const breakpoint = context.currentBreakpoint;
    

    // <video>
    const video = context.document.createElement("video");
    video.setAttribute("muted", "");
    video.setAttribute("name", "media");
    video.setAttribute("playsinline", "");
    video.setAttribute("autoplay", "");
    video.setAttribute("loop", "");
    video.style.width = "100%";
    video.style.height = "100%";

    const styles = {
            ...applyVideoBorderStyles(widget),
            ...getBaseStyles(widget, breakpoint)
    };

    const source = context.document.createElement("source");
    source.setAttribute("src", videoUrl);
    video.appendChild(source);

    container.appendChild(video);

    container.setAttribute("style", cssUtil.toStyleString(styles));
    container.setAttribute("data-widgetId", widget.uid);
    container.setAttribute("data-widgetType", widget.type);
    container.setAttribute("data-widgetParent", widget.parent);
    

    parent.appendChild(container);
    return container;
}

function getVideoUrl(context, widget) {
    const media = widget.content;
    if (!media || media.type !== "video") return null;

    const key = media.key || media.url;
    if (!key) return null;

    // matches: <source src={`${IMAGE_CDN_ENDPOINT}/${url}`} />
    return `${IMAGE_CDN_ENDPOINT}/${key}`;
}

function applyVideoBorderStyles(widget) {
    const styles = {};
    const border = widget?.properties?.desktop?.border;
    if (!border) return styles;

    let color = "";

    if (border.color) {
        if (border.color.type === "gradient") {
            color = cssUtil.getCssGradient(border.color);
        } else if (border.color.type === "solid") {
            color = cssUtil.getCssColor(border.color);
        }
    }

    if (border.radius) {
        const r = border.radius;
        if (r.topLeft) styles["border-top-left-radius"] = `${r.topLeft}px`;
        if (r.topRight) styles["border-top-right-radius"] = `${r.topRight}px`;
        if (r.bottomRight) styles["border-bottom-right-radius"] = `${r.bottomRight}px`;
        if (r.bottomLeft) styles["border-bottom-left-radius"] = `${r.bottomLeft}px`;
    }

    if (color) styles["border-color"] = color;

    const width = border.width || "0";
    styles["border-width"] = `${width}px`;
    styles["border-style"] = "solid";

    return styles;
}
